<template>
  <div>
    <div class="containerView">
      <div class="rowFlex alignitems jus-btw p-tb-16">
        <!-- <div class="searchView" @click.stop="onSearch">
          <img src="@/assets/image/statisticManage/search@3x.png" class="imgView48" />
          <div class="searchInfoView one-text" :style="{color:searchInfoName ? '#3B3A38' : '#898887'}">{{searchInfoName ? searchInfoName : '请输入成员昵称'}}</div>
        </div> -->
        <van-search
            v-model="queryData.memName"
            placeholder="请输入客户昵称"
            shape="round"
            background="#FFFFFF"
            class="searchView"
            @search="onSearch"
        >
          <template #left-icon style="display: flex;align-items: center;margin-right: 4px;">
            <img src="@/assets/image/statisticManage/search@3x.png" class="imgView48"/>
          </template>
        </van-search>
        <img v-if="filterItems && Object.keys(filterItems).length > 0" src="@/assets/image/statisticManage/filtered@3x.png" class="imgView48" @click="handleFilter"/>
        <img v-else src="@/assets/image/statisticManage/filter@3x.png" class="imgView48" @click="handleFilter"/>
      </div>
    </div>
    <div class="sectionView">
      <div class="sectionTitle">流失客户列表（{{total}}）</div>
    </div>
    <div class="containerView" style="background: #F2F2F2;padding: 0 0;width: 100%">
      <van-pull-refresh
          v-model="refreshing"
          @refresh="onRefresh"
      >
        <van-list
            class="listView"
            v-model="loading"
            :finished="finished"
            :error="error"
            finished-text="没有更多信息了～"
            error-text="数据加载失败，请重试"
            @load="onLoad"
        >
          <div class="columnFlex bgwhite m-b-12 p-lr-24" v-for="(item,index) in list" :key="index">
            <div class="listItem">
              <img :src="!isNull(item.handPic) ? item.handPic : defaultHeadImg" class="headImg"/>
              <div class="contentView">
                <div class="itemTopView">
                  <div class="leftView">
                    <div class="title one-text">{{item.memName}}</div>
                    <div class="source one-text">@{{item.memberType == 1 ? '微信' : item.compName}}</div>
                  </div>
                  <div class="rightView" @click.stop="handleMemberDetail(item)">
                    <div
                        :class="['btn ', (((item.vos && item.vos.length == 0) || !item.vos) && ((item.grade && item.grade == '') || !item.grade)) ? 'disableBtn' : 'normalBtn']">
                      查看客户画像
                    </div>
                    <img src="@/assets/image/statisticManage/next@3x.png" class="imgView24" style="margin: 0 0 2px 5px"/>
                  </div>
                </div>
                <div class="itemMiddle">
                  <img src="../../../../assets/image/statisticManage/time@3x.png" class="imgView32" />
                  <div class="itemTime">
                    流失时间：{{formatTime(item.quitTime,'YYYY-MM-DD')}}
                  </div>
                </div>
                <div class="itemBottom">
                  <div class="rowFlex alignitems">
                    <div class="bottomTitle">会员等级：</div>
                    <div class="bottomInfo">{{!isNull(item.vipType) && item.vipType == 3 ? item.grade : '未成为线上线下会员'}}</div>
                  </div>
                  <div v-if="!isNull(item.vipType) && item.vipType == 3" class="rowFlex alignitems jus-btw">
                    <div class="rowFlex alignitems">
                      <div class="bottomTitle">客单价：</div>
                      <div class="bottomRedInfo">{{formateNumber(getTransformData(item.kdj,''))}}</div>
                    </div>
                    <div class="rowFlex alignitems">
                      <div class="bottomTitle">最近购买品类：</div>
                      <div class="bottomInfo">{{item.nearBuyType}}</div>
                    </div>
                  </div>
                  <div v-if="!isNull(item.vipType) && item.vipType == 3" class="rowFlex alignitems">
                    <div class="bottomTitle">最近买单时间：</div>
                    <div class="bottomInfo">{{formatTime(item.nearBuyTime,'YYYY-MM-DD')}}</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="line-1e1"></div>
            <van-collapse v-model="activeNames" :border="false">
              <van-collapse-item v-if="item.vos && item.vos.length > 0" :title="`现存客户成员：${item.vos.length}`" :name="`vos${index}`">
                <template #right-icon>
                  <div v-if="activeNames.indexOf(`vos${index}`) > -1" class="rowFlex alignitems">
                    <img src="@/assets/image/statisticManage/detail_up@3x.png" class="imgView48"/>
                  </div>
                  <div v-else class="rowFlex alignitems">
                    <img src="@/assets/image/statisticManage/detail_down@3x.png" class="imgView48"/>
                  </div>
                </template>
                <div class="collapseContent">
                  <div class="rowFlex alignitems jus-btw" v-for="(mItem,mIndex) in item.vos" :key="mIndex">
                    <div class="rowFlex alignitems">
                      <img :src="!isNull(mItem.userAvatar) ? mItem.userAvatar : defaultHeadImg" class="imgView36 radius50 m-r-12" />
                      <div class="c4a0 lineHeight36 bold400">{{getTransformData(mItem.userName)}}</div>
                    </div>
                    <div class="bold400 cccc lineHeight40">添加时间：{{getTransformData(mItem.joinTime)}}</div>
                  </div>
                </div>
              </van-collapse-item>
              <div v-else class="rowFlex alignitems p-tb-24">
                <div class="ca38 f28 bold500 lineHeight40">现存客户成员：0</div>
                <div class="empty">该用户无现存员工好友</div>
              </div>
            </van-collapse>
          </div>
        </van-list>
      </van-pull-refresh>
      <filterDawer
        :show="showFilter"
        :corpId="corpId"
        :collapseItemList="collapseItemList"
        :isTimeDefault="false"
        :activeNames="filterActiveNames"
        :isBottom="false"
        @close="handleClose"
        @confirm="handleConfirm"
      ></filterDawer>
    </div>
  </div>
</template>

<script>
import utils from "@/utils/common";
import http from "@/utils/axios";
import moment from "moment";
import filterDawer from "../../components/filterDawer.vue";
import {initWxAgentConfig,launchMiniprogram} from "@/utils/weixin";

export default ({
  components:{
    filterDawer
  },
  props:{
    memberId:{
      type:String,
      default:() => {
        return ''
      }
    },
    corpId:{
      type:String,
      default:() => {
        return ''
      }
    }
  },
  data() {
    return {
      defaultHeadImg:require('@/assets/image/statisticManage/defaultHead@3x.png'),
      wx: null,
      activeNames:[],
      dataInfo:{},
      filterActiveNames:['member'],
      showFilter:false,
      queryData:{
        memName:'',
        timeType:0,
        orderType: 0,
        orderVal: 0,
        // startTime:`${new Date().getFullYear()}/${new Date().getMonth() + 1}/${new Date().getDate()}`,
        // endTime:`${new Date().getFullYear()}/${new Date().getMonth() + 1}/${new Date().getDate()}`,
      },
      list: [],
      page: 1,
      pageSize: 10,
      total: 0,
      loading: false,
      finished: false,
      refreshing: false,
      error: false,
      searchInfo:'',
      filterItemIds:{},
      filterItems:{},
      customeTime:'',
      searchInfoName:'',
      selectItemIds:[],
      selectItems:[],
      collapseItemList:[
        {
          name: 'member',
          title: '用户信息',
          filterItems: [
            {
              title: '会员',
              key: 'vipFlag',
              isMultiple:false,
              list: [
                {
                  id: '-1',
                  title: '全部'
                },
                {
                  id: '0',
                  title: '会员'
                },
                {
                  id: '1',
                  title: '非会员'
                }
              ]
            },
            {
              title: '是否有现存客户成员',
              key: 'hasUser',
              list: [
                {
                  id:'-1',
                  title:'全部'
                },
                {
                  id:'0',
                  title:'是'
                },
                {
                  id:'1',
                  title:'不是'
                }
              ]
            },
            {
              title: '排序依据',
              key: 'orderVal',
              isMultiple:false,
              list: [
                {
                  id: '0',
                  title: '流失时间'
                }
              ]
            },
            {
              title: '排序',
              key: 'orderType',
              isMultiple:false,
              list: [
                {
                  id: '0',
                  title: '降序'
                },
                {
                  id: '1',
                  title: '升序'
                }
              ]
            }
          ]
        }
      ]
    }
  },
  created() {
    // this.$loading.hide();
    // this.getList()
    // this.getInclinationList()
  },
  mounted() {
    if(!utils.isNullData(localStorage.getItem('selectItemIds'))){
      let selectItemIds = JSON.parse(localStorage.getItem('selectItemIds'))
      let selectItems = JSON.parse(localStorage.getItem('selectItems'))
      this.selectItemIds = selectItemIds
      this.selectItems = selectItems
      let names = selectItems.map((item) => {
        return item.name
      })
      this.searchInfo = selectItemIds.join(',')
      this.searchInfoName = names.join(',')
      localStorage.removeItem('selectItemIds')
      localStorage.removeItem('selectItems')
    }
  },
  methods:{
    isNull(val){
      return utils.isNullData(val)
    },
    formateNumber(data){
      if(!utils.isNullData(data)){
        // data = data.toString()
        // if(data.indexOf('.') > -1){
        //   return Number(data).toFixed(2)
        // }
        return utils.formatFloat(Number(data), 2)
      }
      return ''
    },
    /**
     * 查询购买倾向列表
     */
     getInclinationList(){
      http({
        url: "order/dmp/dispatch/memberpush/BsEnterpriseWechatGroupChat/findCategoryList",
        method: "post",
        parmes: {}
      }).then(rps => {
        if (rps.code == 200) {
          let data = rps.data;
          data.forEach((item) => {
            item.title = item.categoryName
          })
          let index = this.collapseItemList.findIndex((item) => {
            return item.name == 'member'
          })
          if (index > -1) {
            let cItem = Object.assign({}, this.collapseItemList[index])
            let objIndex = cItem.filterItems.findIndex((item) => {
              return item.key == 'inclinationNames'
            })
            if (objIndex > -1) {
              cItem.filterItems[objIndex].list = cItem.filterItems[objIndex].list.concat(data)
            }
            this.collapseItemList.splice(index, 1, cItem)
          }
        }else{
          this.$toast('请求异常，请稍后重试')
        }
        this.$loading.hide();
      }).catch(() => {
        this.$loading.hide();
        this.$toast('请求失败，请稍后重试')
      });
    },
    // 下拉刷新
    onRefresh() {
      // 清空列表数据
      this.refreshing = true
      this.finished = false;
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.error = false;
      this.page = 1
      this.total = 0
      this.onLoad();
    },
    // 列表加载数据
    onLoad() {
      if (this.refreshing) {
        this.list = [];
        this.refreshing = false;
      }
      if (this.list.length > 0 && this.list.length >= this.total) {
        this.finished = true
        return
      }
      this.getDataList()
    },
    /**
     * 查询群成员信息
     * */
    getDataList(){
      this.$loading.hide()
      this.loading = true
      let params = Object.assign({}, this.queryData)
      // if(params.timeType == 0){
      //   delete params.startTime
      // }
      if(!utils.isNullData(params.startTime)){
        params.startTime = moment(params.startTime).format('YYYY-MM-DD')
      }
      if(!utils.isNullData(params.endTime)){
        params.endTime = moment(params.endTime).format('YYYY-MM-DD')
      }
      http({
        url: "order/dmp/dispatch/memberpush/BsEnterpriseWechatUser/getUserCusListWithLose",
        method: "post",
        parmes: {
          groupId:this.memberId,
          ...params,
          pageIndex:this.page,
          pageSize:this.pageSize
        }
      }).then(rps => {
        if (rps.code == 200) {
          let data = rps.data;
          this.list = this.list.concat(data.ewChangeExternalChatEventMemVos);
          this.page++
          this.total = data.total ? data.total : this.list.length
          this.loading = false;
          if (this.list.length >= this.total) {
            this.finished = true;
          }
        }else{
          this.loading = false;
          this.error = true;
          this.$toast('请求异常，请稍后重试')
        }
        this.$loading.hide();
      }).catch(() => {
        this.$loading.hide();
        this.loading = false;
        this.error = true;
        this.$toast('请求失败，请稍后重试')
      });
    },
    /**
     * 查看客户画像
     * 跳转员工端小程序
     * appId: wx46724aabbbf28ca6(生产环境)wxc01947134d1a0a1f（开发环境）
     * 跳转页面地址: 
     * */
    handleMemberDetail(item){
      if(((item.vos && item.vos.length == 0) || !item.vos) && utils.isNullData(item.grade)){
        return
      }
      initWxAgentConfig(location.href, this.$wx).then((wx) => {
        this.wx = wx;
        console.log('查看客户画像====')
        let appId = 'wxc01947134d1a0a1f'
        if(window.location.href.indexOf('https://op.chinabeego.com') > -1){
          appId = 'wx46724aabbbf28ca6'
        }
        let isVip = item.vipType == 3 ? 1 : 0
        let path = `/packages/customer/pages/detail/detail?id=${item.memId}&isLogon=${isVip}&isLabelEdit=0&from=groupMember`
        launchMiniprogram(this.wx, appId, path).then((res) => {
          this.$loading.hide();
          console.log('跳转客户画像页面成功')
          console.log(res)
        }).catch((err) => {
          this.$loading.hide();
          console.log('跳转客户画像失败=============')
          console.log(err)
          this.$toast('查看客户画像失败，请稍后重试')
        })
      }).catch((err) => {
        this.$loading.hide();
        this.$toast('跳转失败，请稍后重试')
        console.log('wx注册失败=====')
        console.log(err)
      })
    },
    /**
     * 格式化数据
     */
    getTransformData(data, defaultValue = '') {
      if (utils.isNullData(data)) {
        return defaultValue
      }
      return data;
    },
    // 点击筛选
    handleFilter() {
      this.showFilter = true
    },
    // 关闭筛选框
    handleClose() {
      this.showFilter = false
    },
    // 筛选确认
    handleConfirm(selectItemIds,selectItems,customeTime) {
      this.showFilter = false
      // let queryData = Object.assign({},selectItemIds)
      let queryData = JSON.parse(JSON.stringify(selectItemIds))
      for(let key in queryData){
        let val = queryData[key]
        if(val instanceof Array){
          let index = val.indexOf('-1')
          if(index > -1){
            queryData[key].splice(index,1)
          }
        }else{
          if(val == '-1'){
            queryData[key] = ''
          }
        }
      }
      this.filterItemIds = selectItemIds
      this.filterItems = selectItems
      if(!utils.isNullData(customeTime)){
        this.customeTime = customeTime
        let startTime = moment(customeTime.split('-')[0]).format('YYYY-MM-DD')
        let endTime = moment(customeTime.split('-')[1]).format('YYYY-MM-DD')
        queryData.startTime = startTime
        queryData.endTime = endTime
      }else{
        if(selectItems.timeType && !utils.isNullData(selectItems.timeType.value)){
          let startTime = moment(selectItems.timeType.value.split('-')[0]).format('YYYY-MM-DD')
          let endTime = moment(selectItems.timeType.value.split('-')[1]).format('YYYY-MM-DD')
          queryData.startTime = startTime
          queryData.endTime = endTime
        }else{
          delete queryData.startTime
          delete queryData.endTime
          delete this.queryData.startTime
          delete this.queryData.endTime
        }
      }
      this.queryData = Object.assign({},this.queryData,queryData)
      if(utils.isNullData(this.queryData.timeType)){
        this.queryData.timeType = 0
      }
      this.onRefresh()
    },
    // 搜索
    onSearch() {
      this.onRefresh()
      // localStorage.setItem('currentTab','member')
      // this.$router.push({
      //   path:'/searchPage',
      //   query:{
      //     pageType:'memberList',
      //     placeholder:'请输入成员昵称'
      //   }
      // })

    },
    /**
     * 格式化时间
     * @param {*} time 
     * @param {*} formate 
     */
    formatTime(time, formate = 'YYYY-MM-DD'){
      if(!utils.isNullData(time)){
        return moment(time).format(formate)
      }
      return ''
    }
  }
})
</script>
<style lang="less" scoped>
@import url("../../style/index.css");
/deep/ .van-cell {
  padding: 24px 0 !important;

  &::after {
    border-bottom: none !important;
  }
}
/deep/ .van-collapse-item__content {
  padding: 24px 24px !important;
}

/deep/ .van-collapse-item--border {
  &::after {
    border-top: none !important;
  }
}
/deep/ .van-cell__title{
  font-size: 28px;
  font-weight: 500;
  color: #3B3A38;
  line-height: 40px;
}
.empty{
  background: #FDF2F2;
  border-radius: 0px 18px 18px 18px;
  padding: 4px 12px;
  font-size: 22px;
  font-weight: 400;
  color: #E15554;
  line-height: 28px;
  margin-left: 16px;
}
.sectionView{
  background: #F2F2F2;
  .sectionTitle{
    padding: 24px 24px 16px 24px;
    font-size: 28px;
    font-weight: 500;
    color: #3B3A38;
    line-height: 40px;
  }
}
.containerView {
  width: calc(100% - 48px);
  padding: 16px 24px;
  background: #FFFFFF;
  .searchView{
    display: flex;
    align-items: center;
    //justify-content: space-between;
    // width: calc(90% - 32px);
    // padding: 8px 16px;
    width: 100%;
    padding: 0 16px 0 0;
    height: 64px;
    background: #F6F6F6;
    border-radius: 32px;
    margin-left: 4px;
    font-size: 28px;
    font-weight: 400;
    color: #898887;
    line-height: 40px;
    .searchInfoView{
      font-size: 28px;
      font-weight: 400;
      color: #898887;
      line-height: 40px;
      margin-left: 4px;
      width: calc(100% - 52px);
    }
  }
  .listView{
    width: 100%;
    background: #F2F2F2;
  }
  .line-1e1 {
    position: relative;
    width: 100%;
    height: 1px;

    &::after {
      position: absolute;
      top: 0;
      left: 0;
      content: ' ';
      width: 200%;
      height: 200%;
      background: #E1E1E1;
      transform-origin: 0 0;
      transform: scale(0.5);
    }
  }
  .listItem{
    display: flex;
    padding: 24px 0;
    width: 100%;
    .logo{
      background: linear-gradient(90deg, #FFECCD 0%, #F5D6A4 100%);
      border-radius: 4px;
      padding: 6px 0;
      font-size: 20px;
      font-weight: 400;
      color: #BA8956;
      line-height: 28px;
      width: 52px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .companyInfo{
      font-size: 28px;
      font-weight: 400;
      color: #F08E3C;
      line-height: 36px;
      margin-left: 8px;
    }
    .headImg{
      width: 96px;
      height: 96px;
      border-radius: 10px;
    }
    .contentView{
      display: flex;
      flex-direction: column;
      margin-left: 24px;
      width: calc(100% - 120px);
      .itemTopView{
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 8px;
        .name{
          font-size: 34px;
          color: #3B3A38;
          line-height: 41px;
        }
        .leftView{
          width: calc(100% - 200px);
          display: flex;
          align-items: center;
          .title{
            font-size: 34px;
            color: #3B3A38;
            line-height: 41px;
            max-width: calc(100% - 100px);
          }
          .source{
            font-size: 28px;
            font-weight: 400;
            color: #46C18A;
            line-height: 36px;
            margin-left: 8px;
          }
        }
        .rightView{
          display: flex;
          align-items: center;
          .btn{
            font-size: 24px;
            font-weight: 400;
            display: flex;
            align-items: center;
            line-height: 32px;
            height: 32px;
          }
          .normalBtn{
            color: #4466F5;
          }
          .disableBtn{
            color: #B4B4B4
          }
        }
      }
      .itemMiddle{
        display: flex;
        align-items: center;
        margin-bottom: 24px;
        .itemTime{
          font-size: 24px;
          font-weight: 400;
          color: #B4BCCC;
          height: 32px;
          line-height: 32px;
          margin-top: 5px;
          margin-left: 12px;
        }
      }
      .itemBottom{
        background: rgba(68,102,245,0.06);
        border-radius: 12px;
        padding: 8px 16px;
        .bottomTitle{
          font-size: 22px;
          font-weight: 400;
          color: #B4BCCC;
          line-height: 40px;
        }
        .bottomInfo{
          font-size: 24px;
          font-weight: 500;
          color: #5C636D;
          line-height: 40px;
        }
        .bottomRedInfo{
          font-size: 24px;
          font-weight: 500;
          color: #E15554;
          line-height: 40px;
        }
      }
      .collapseContent{

      }
    }
  }
}
.van-search .van-cell {
  display: flex;
  align-items: center;
  padding: 0 0;
}

/deep/ .van-search__content--round {
  border-radius: 32px;

  .van-field__left-icon {
    display: flex !important;
    align-items: center !important;
    margin-right: 4px !important;
  }
}

.van-search__content {
  background: #F6F6F6 !important;
  height: 100% !important;
}
/deep/ .van-field__control{
  width: calc(100% - 64px);
}
</style>
